import merge from 'classnames';

import { SvgIconContainer } from '@/components/generic/SvgIconContainer';

import { SvgIconContainerIconProps } from '../types';

export const IconWarningV2 = ({ classes = {}, ...containerProps }: SvgIconContainerIconProps) => (
  <SvgIconContainer role="img" {...containerProps} className={merge(classes.container)}>
    <svg
      className={merge(classes.icon)}
      fill="none"
      height="38"
      viewBox="0 0 42 38"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M22.3546 1.875C21.5848 0.541666 19.6603 0.541668 18.8905 1.875L0.270932 34.125C-0.498869 35.4583 0.46339 37.125 2.00299 37.125H39.2421C40.7817 37.125 41.7439 35.4583 40.9741 34.125L22.3546 1.875ZM19.1225 12.875H23.1225V24.9399H19.1225V12.875ZM19.1225 26.7399H23.1225V30.875H19.1225V26.7399Z"
        fill="#2774AE"
        fillRule="evenodd"
      />
    </svg>
  </SvgIconContainer>
);
